import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#03A0E3",
      d: "M.797 16.598h32.406v-5.196H.797zm12.39 11.018h20.015V22.42H13.186zM20.811 5.58h12.39V.384h-12.39z"
    }, null, -1)
  ])))
}
export default { render: render }